import { IEvent } from "~app/common/services/cqs/event.service";

export class MapTabModeChangedEvent implements IEvent {
    $type: string;
    id: any;

    static readonly EVENTNAME = "TransportplaneraModeChangedEvent";
    constructor(id: string) {
        this.id = id;
        this.$type = `common.components.map.${MapTabModeChangedEvent.EVENTNAME},${MapTabModeChangedEvent.EVENTNAME}`;
    }
}
